const DEFAULT_COOKIE_DAYS = 30;

const getCookieName = key => `aleta_${key}`;

const buildCookieAttributes = days => {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    return `expires=${expires}; path=/; SameSite=Lax${secure}`;
};

const writeCookie = (key, value, days = DEFAULT_COOKIE_DAYS) => {
    document.cookie = `${getCookieName(key)}=${encodeURIComponent(value)}; ${buildCookieAttributes(days)}`;
};

const readCookie = key => {
    const cookieName = `${getCookieName(key)}=`;
    const cookies = document.cookie.split(';');
    const matched = cookies.find(cookie => cookie.trim().startsWith(cookieName));
    if (!matched) return null;
    return decodeURIComponent(matched.trim().slice(cookieName.length));
};

const removeCookie = key => {
    document.cookie = `${getCookieName(key)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
};

export const getPersistentItem = key => {
    try {
        const value = localStorage.getItem(key);
        if (value !== null) return value;
    } catch (error) {
        console.warn(`[storage] localStorage getItem failed for "${key}"`, error);
    }

    try {
        return readCookie(key);
    } catch (error) {
        console.warn(`[storage] cookie read failed for "${key}"`, error);
        return null;
    }
};

export const setPersistentItem = (key, value, options = {}) => {
    const { cookieDays = DEFAULT_COOKIE_DAYS, alwaysSyncCookie = false } = options;

    let savedInLocalStorage = false;
    try {
        localStorage.setItem(key, value);
        savedInLocalStorage = true;
    } catch (error) {
        console.warn(`[storage] localStorage setItem failed for "${key}"`, error);
    }

    if (!savedInLocalStorage || alwaysSyncCookie) {
        try {
            writeCookie(key, value, cookieDays);
            return true;
        } catch (error) {
            console.warn(`[storage] cookie write failed for "${key}"`, error);
            return false;
        }
    }

    return true;
};

export const removePersistentItem = key => {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        console.warn(`[storage] localStorage removeItem failed for "${key}"`, error);
    }

    try {
        removeCookie(key);
    } catch (error) {
        console.warn(`[storage] cookie remove failed for "${key}"`, error);
    }
};
